import { Grid } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import React from "react";
import AllUsersHoldings from "../AllUsersHoldings";
import PlaceStopLoss from "./PlaceStopLoss";
import { PreMarketBuy } from "./PreMarketBuy";
import SurveillanceHistory from "./SurveillanceHistory";
import TradeSwitch from "../TradeSwitch";
import { TRADE_SWITCH_TYPE } from "../../util/constant";

const AdminActions = ({ user }) => {
    return (
        <>
            <Grid item xs={12} md={12}>
                <Typography variant="h4" gutterBottom component="div">
                    Admin Actions
                </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
                <TradeSwitch user={user} type={TRADE_SWITCH_TYPE.DAY_TRADE} />
            </Grid>
            <Grid item xs={12} md={12}>
                <PlaceStopLoss user={user} />
            </Grid>
            <Grid item xs={12} md={8}>
                <AllUsersHoldings user={user} />
            </Grid>
            <Grid item xs={12} md={8}>
                <PreMarketBuy user={user} />
            </Grid>
            <Grid item xs={12} md={8}>
                <SurveillanceHistory user={user} />
            </Grid>
        </>
    );
}

export default AdminActions